import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getQuizPhaseThunk,
  startQuizThunk,
} from "../../store/quiz/quiz.thunks";
import { useEffect } from "react";
import { resetQuizState } from "../../store/quiz/quiz.slice";
import { toast } from "react-toastify";

const HeroRight = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { phase, sessionId } = useSelector((state) => state.quiz);

  useEffect(() => {
    dispatch(getQuizPhaseThunk());
  }, [dispatch]);

  // Redirigir automáticamente a la página de talentos si el quiz está completado
  useEffect(() => {
    if (phase === "completada") {
      navigate("/mis-talentos");
    }
  }, [phase, navigate]);

  const handleClick = async () => {
    if (!navigator.onLine) {
      toast.error("No tienes conexión a internet");
      return;
    }

    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    }
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    }

    if (phase === "en_progreso" && sessionId) {
      navigate("/test-quiz");
    } else {
      // LIMPIAR ESTADO ANTES DE CREAR NUEVO QUIZ
      dispatch(resetQuizState());

      const result = await dispatch(startQuizThunk());

      if (result.meta.requestStatus === "fulfilled") {
        navigate("/test-quiz");
      }
    }
  };

  const isContinuing = phase === "en_progreso";

  return (
    <div className="hero-text-wrapper">
      <h1 className="hero-title">BIENVENIDO {user.nombre_completo}</h1>

      <h4 className="hero-subtitle">
        {isContinuing
          ? "Tienes un test en progreso"
          : "Tienes un test que contestar"}
      </h4>

      <div className="hero-buttons mt-4">
        <button
          className={`btn mt-4 ${
            isContinuing ? "hero-btn-continue" : "hero-btn-urgent"
          }`}
          onClick={handleClick}
        >
          <Icon
            icon={isContinuing ? "solar:play-bold" : "solar:bolt-bold"}
            className="me-2 hero-btn-icon"
          />

          {isContinuing ? "Continuar test" : "Comenzar ahora"}
        </button>
        <button
          className="hero-btn-tutorial"
          onClick={() => navigate("/tutorial-video")}
        >
          <Icon icon="solar:book-2-bold" className="me-2 hero-btn-icon" />
          Ver tutorial
        </button>
      </div>
    </div>
  );
};

export default HeroRight;
